import { addDays } from 'date-fns';
import { fromDateStampObject, makeDateStampObject } from '../time';
import { makeExpirationDate } from './makers';
export const fromExpirationDate = (expirationDate, now)=>{
    if (expirationDate == null || expirationDate.type === 'none') return null;
    const newDate = addDays(now, expirationDate.days);
    return makeDateStampObject(newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate());
};
export const fromDatestampObjectToExpirationDate = (datestampObject, createdOn)=>{
    if (datestampObject === null) return makeExpirationDate();
    const oneDay = 1000 * 60 * 60 * 24;
    const daysBetween = Math.ceil((fromDateStampObject(datestampObject).getTime() - createdOn) / oneDay);
    return makeExpirationDate(daysBetween);
};
